export default __webpack_public_path__ + "static/media/Reception.e34d5e1f.png";